import React from 'react';
import StepperActions from '../stepper-actions';
import { FlatButton } from 'material-ui';
import NonAccomRateForm from '../rate-forms/non-accommo-rates-form-templates/non-accom-rates-form';
import R from 'ramda';

const NonAccomRates = ({
  componentIndex,
  updateFieldValue,
  updateFieldWithKeyPath,
  goToNextStep,
  goToPreviousStep,
  cancelFunc,
  cancelText,
  calculateStandardNonAccomRateTable,
  updateFormData,
  ...fieldValues }) => {
  const nonAccomStandard = fieldValues.nonAccomStandard;
  const retailOrNett = fieldValues.rateType === 'includeCommission' ? 'retail' : 'nett';
  const noRatesEntered = !R.values(nonAccomStandard[retailOrNett]).some(x => x);
  const shouldDisableForMultiDay = R.path([retailOrNett, 'single'], nonAccomStandard)
    && R.path([retailOrNett, 'single supplement'], nonAccomStandard);
  const checkIfShouldDisableForTransfersPriceBreak = (() => {
    const checkForSingleDetail = detail => {
      return (detail.maxAdultsPlusChild || detail.minGuests)
        && detail.baseRate
        && (fieldValues.rateType === 'includeCommission' ? detail.retailRate : true);
    };
    const filteredArray = fieldValues.transfersOrPriceBreak.filter(checkForSingleDetail);
    return !Boolean(filteredArray.length);
  })();
  const shouldDisable = (() => {
    if (!fieldValues.currency) return true;
    if (!fieldValues.taxInclusion) return true;
    if (fieldValues.taxInclusion !== 'exempt' && !fieldValues.taxType) return true;
    if (fieldValues.rateType === 'includeCommission' && !fieldValues.commissionPercentage) return true;
    if (fieldValues.nonStandardTemplateType === 'standard') return noRatesEntered;
    if (fieldValues.nonStandardTemplateType === 'multiDayTour') {
      return noRatesEntered || shouldDisableForMultiDay;
    }
    return checkIfShouldDisableForTransfersPriceBreak;
  })();
  return (
    <div style={{ padding: '48px', paddingTop: '24px' }}>
      <NonAccomRateForm
        {...fieldValues}
        showTaxCurrency
        updateFieldWithKeyPath={updateFieldWithKeyPath}
        updateFieldValue={updateFieldValue}
        updateFormData={updateFormData}
      />
      <StepperActions
        style={{ clear: 'both', position: 'relative', top: '12px' }}
        showBackButton
        backButtonFunc={() => goToPreviousStep(componentIndex)}
        rightButtons={
          <div>
            <FlatButton
              label={cancelText}
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              primary
              onTouchTap={cancelFunc}
            />
            <FlatButton
              onTouchTap={() => {
                calculateStandardNonAccomRateTable();
                goToNextStep(componentIndex);
              }}
              secondary
              label={'continue'}
              disabled={shouldDisable}
              labelStyle={{ fontWeight: '600' }}
            />
          </div>
        }
      />
    </div>
  );
};

export default NonAccomRates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/2-non-accom-rates.jsx